import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { igolfMappingRequest } from "API/apiConfig";
import {
  CourseCopyCreate,
  CourseCreate,
  CourseGPSMapUpdate,
  CourseGPSNameList,
  CourseGPSVectorMapCreate,
  CourseGPSVectorMapDetails,
  CourseGPSVectorMapShiftUpdate,
  CourseGPSVectorMapUpdate,
  CourseLayoutList,
  CourseMappingGPSDetails,
  CourseMappingGPSUpdate,
  CourseMappingScorecardDetails,
  CourseMappingScorecardImageDelete,
  CourseMappingScorecardImageUpload,
  CourseMappingScorecardUpdate,
  CourseRenderingCreate,
  CourseRenderingDetails,
  CourseRenderingUpdate,
  CourseRenderingOptionList,
  CourseSyncOutputCreate,
  CourseTeeColorList,
  CourseTeeTypeList,
  CourseTeeTypeCreate,
  CourseUpdate,
  LanguageList,
  MappingTaskNoteCreate,
  CourseMappingLayoutUpdate,
  MappingTaskNoteList,
  VectorOutputCreate,
  CourseGPSVectorMapRemove
} from "API/apiRequest";
import { getGeocode } from "API/geoCode";
// import { dummyGPS } from "API/dummyCourseGPSVector";

const initialState = {
  courseMapDetails: {
    courseMapData: null,
    courseGPSMappingData: {
      GPSList: [],
      Status: -1,
      clubLat: -1,
      clubLon: -1,
      layoutHoles: -1,
    },
  },
  courseGPSNameList: [],
  transformedCourseData: [],
  transformedHoleData: [],
  course_sync_output_create_status: "idle",
  vector_output_create_status: "idle",
  course_gps_vector_details_status: "idle",
  course_gps_name_list_status: "idle",
  course_gps_name_mapping_status: "idle",
  course_gps_vector_map_update_status: "idle",
  course_gps_vector_map_create_status: "idle",
  google_geocode_api_status: "idle",
  global_save_status: "idle",
  course_scorecard_details_status:"idle",
  course_mapping_note_list_status:"idle",
  course_mapping_note_create_status:"idle",
  course_scorecard_details:{},
  isLocalUpdating: false,
  selectedCourseZoneType: {},
  editableCourseItem: {},
  // editableHazardItem: {},
  visibleCourseElements: [],
  visibleFacilityElements: {},
  shapePropertiesType: null,
  polygonPropertiesType: null,
  polygonPropertiesDesc: null,
  bridgePropertiesDesc: null,
  markerHazardTreeDesc: null,
  markerHazardTreeSize: null,
  markerHazardTreeType: null,
  shapePropertiesSize: null,
  shapePropertiesDesc: null,
  cliffPropertiesDesc: null,
  cliffPropertiesType: null,
  nativeAreaPolygonDesc: null,
  nativeAreaPolygonType: null,
  nativeAreaPolygonSize: null,
  fixtureMarkerSize: null,
  fixtureMarkerType: null,
  forestPolygonType: null,
  shapeBackgroundPropertiesType: null,
  shapeBackgroundPropertiesDesc: null,
  creekSizeValue: null,
  lavaTypeValue: null,
  residenceDescValue: null,
  residenceTypeValue: null,
  residenceSizeValue: null,
  buildingDescValue: null,
  buildingTypeValue: null,
  buildingSizeValue: null,
  parkingLotDescValue: null,
  streetDescValue: null,
  streetSizeValue: null,
  fenceDescValue: null,
  fenceSizeValue: null,
  waterDescValue: null,
  waterTypeValue: null,
  waterSizeValue: null,
  pathDescValue: null,
  clubhouseDescValue: null,
  clubhouseTypeValue: null,
  clubhouseSizeValue: null,
  isDrawingStatus: false,
  google_location_data: null,
  isMoveModeEnabled: false,
  movableMapElement: {},
  course_mapping_note_list:[],
  // selectedCourseGroup: "",
  // selectedZone: {
  //   zone: "",
  //   details: [],
  //   type: "",
  //   visibleAreas: [],
  //   editableArea: "",
  // },
  course_layout_list_status: "idle",
  course_layout_list_data: {},
  course_create_status: "idle",
  course_create_data: {},
  course_clubhouse_Lat_Lon_create_status: "idle",
  course_clubhouse_Lat_Lon_create_data: {},
  course_update_status: "idle",
  course_update_data: {},
  course_copy_status: "idle",
  course_copy_data: {},
  copiedCourseDetails:{},
  holeWiseData: {},
  selectedHoleNo: null,
  language_list_status: "idle",
  language_list_data: {},
  course_teecolor_list_status: "idle",
  course_teecolor_list_data: {},
  course_teetype_list_status: "idle",
  course_teetype_list_data: {},
  upload_course_scorecard_image_status: "idle",
  upload_course_scorecard_image_data: {},
  delete_course_scorecard_image_status: "idle",
  delete_course_scorecard_image_data: {},
  create_course_rendering_status: "idle",
  create_course_rendering_data: {},
  details_course_rendering_status: "idle",
  details_course_rendering_data: {},
  details_course_rendering_courseInt: null,
  update_course_rendering_status: "idle",
  update_course_rendering_data: {},
  course_rendering_options_status: "idle",
  course_rendering_options_data: {},
  selectedEditedMarkerPoint : 1,
  setMarkerPointLatlon: []
};

//CourseGPSNameList

export const course_gps_name_list = createAsyncThunk(
  "/CourseGPSNameList",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(CourseGPSNameList, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data }; //when API is ready
    // let resData = { data: dummyGPS };

    return resData;
  }
);

export const course_map_gps_vector_details = createAsyncThunk(
  "/CourseGPSVectorMapDetails",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(CourseGPSVectorMapDetails, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data }; //when API is ready
    // let resData = { data: dummyGPS };

    return resData;
  }
);

export const course_map_gps_mapping_details = createAsyncThunk(
  "/CourseMappingGPSDetails",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(CourseMappingGPSDetails, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data }; //when API is ready
    // let resData = { data: dummyGPS };

    return resData;
  }
);
//CourseGPSVectorMapUpdate
export const course_gps_vector_map_update = createAsyncThunk(
  "/CourseGPSVectorMapUpdate",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(CourseGPSVectorMapUpdate, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data }; //when API is ready
    // let resData = { data: dummyGPS };

    return resData;
  }
);
// CourseMappingGPSUpdate
export const course_mapping_gps_update = createAsyncThunk(
  "/CourseMappingGPSUpdate",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(CourseMappingGPSUpdate, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data }; //when API is ready
    // let resData = { data: dummyGPS };

    return resData;
  }
);
// CourseGPSVectorMapRemove
export const course_gps_vector_map_remove = createAsyncThunk(
  "/CourseGPSVectorMapRemove",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(CourseGPSVectorMapRemove, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data };
    return resData;
  }
);
//CourseGPSVectorMapCreate
export const course_gps_vector_map_create = createAsyncThunk(
  "/CourseGPSVectorMapCreate",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(CourseGPSVectorMapCreate, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data }; //when API is ready
    // let resData = { data: dummyGPS };

    return resData;
  }
);
export const course_sync_output_create = createAsyncThunk(
  "/CourseSyncOutputCreate",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(CourseSyncOutputCreate, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data, status: res?.status };

    return resData;
  }
);

export const vector_output_create = createAsyncThunk(
  "/VectorOutputCreate",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(VectorOutputCreate, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data, status: res?.status };

    return resData;
  }
);

export const fetch_google_geocode = createAsyncThunk(
  "/FetchGoogleJioCode",
  async ({ address }) => {
    let searchResult = await getGeocode(address).then((res) => res);
    return searchResult?.data;
  }
);

export const course_scorecard_details = createAsyncThunk(
  "/CourseMappingScorecardDetails",
  async ({ body, user }) => {
    let searchResult = await igolfMappingRequest(CourseMappingScorecardDetails, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: searchResult?.data }; //when API is ready

    return resData;
  }
);

export const course_mapping_note_list = createAsyncThunk(
  "/CourseMappingNoteList",
  async ({ body, user }) => {
    let searchResult = await igolfMappingRequest(MappingTaskNoteList, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: searchResult?.data }; //when API is ready
    return resData;
  }
);

export const course_mapping_note_create = createAsyncThunk(
  "/MappingTaskNoteCreate",
  async ({ body, user }) => {
    let searchResult = await igolfMappingRequest(MappingTaskNoteCreate, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: searchResult?.data }; //when API is ready
    return resData;
  }
);

export const course_mapping_layout_update = createAsyncThunk(
  "/CourseMappingLayoutUpdate",
  async ({ body, user }) => {
    let searchResult = await igolfMappingRequest(CourseMappingLayoutUpdate, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: searchResult?.data };
    return resData;
  }
);

export const course_gps_vector_map_shift_update = createAsyncThunk(
  "/CourseGPSVectorMapShiftUpdate",
  async ({ body, user }) => {
    let searchResult = await igolfMappingRequest(CourseGPSVectorMapShiftUpdate, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: searchResult?.data };
    return resData;
  }
);

// layout holes
export const course_layout_list = createAsyncThunk(
  "/CourseLayoutList",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(CourseLayoutList, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data };
    return resData;
  }
);

export const course_create = createAsyncThunk(
  "/Coursecreate",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(CourseCreate, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data };
    return resData;
  }
);
// clubhouseLat&Lon 
export const course_clubhouse_Lat_Lon_create = createAsyncThunk(
  "/CourseGPSMapUpdate",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(CourseGPSMapUpdate, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data }; //when API is ready
    return resData;
  }
);

// course details update
export const course_update = createAsyncThunk(
  "/CourseUpdate",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(CourseUpdate, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data }; //when API is ready
    return resData;
  }
);

export const course_copy = createAsyncThunk(
  "/CourseCopy",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(CourseCopyCreate, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data }; //when API is ready
    return resData;
  }
);

export const language_list = createAsyncThunk(
  "/languageList",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(LanguageList, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data }; //when API is ready
    return resData;
  }
);

export const course_teecolor_list = createAsyncThunk(
  "/CourseTeeColorList",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(CourseTeeColorList, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data };
    return resData;
  }
);

export const course_teetype_list = createAsyncThunk(
  "/CourseTeeTypeList",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(CourseTeeTypeList, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data };
    return resData;
  }
);
export const course_teetype_create = createAsyncThunk(
  "/CourseTeeTypeCreate",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(CourseTeeTypeCreate, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data };
    return resData;
  }
);
export const update_coursemap_scorecard = createAsyncThunk(
  "/UpdateCourseMapScorecard",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(CourseMappingScorecardUpdate, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data };
    return resData;
  }
);

export const upload_coursemap_scorecard_image = createAsyncThunk(
  "/UploadCourseMapScorecardImage",
  async ({ body, user,image  }) => {
    let res = await igolfMappingRequest(CourseMappingScorecardImageUpload, body, user,image)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data };
    return resData;
  }
);

// delete coursemap image
export const Delete_coursemap_scorecard_image = createAsyncThunk(
  "/DeleteCourseMapScorecardImage",
  async ({ body, user,image  }) => {
    let res = await igolfMappingRequest(CourseMappingScorecardImageDelete, body, user,image)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data };
    return resData;
  }
);
export const create_coursemap_rendering = createAsyncThunk(
  "/CourseRenderingCreate",
  async ({ body, user  }) => {
    let res = await igolfMappingRequest(CourseRenderingCreate, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data };
    return resData;
  }
);
export const details_coursemap_rendering = createAsyncThunk(
  "/CourseRenderingDetails",
  async ({ body, user  }) => {
    let res = await igolfMappingRequest(CourseRenderingDetails, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data };
    return resData;
  }
);
export const update_coursemap_rendering = createAsyncThunk(
  "/CourseRenderingUpdate",
  async ({ body, user  }) => {
    let res = await igolfMappingRequest(CourseRenderingUpdate, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data };
    return resData;
  }
);
export const course_rendering_option_list = createAsyncThunk(
  "/CourseRenderingOptionList",
  async ({ body, user }) => {
    let res = await igolfMappingRequest(CourseRenderingOptionList, body, user)
      .then((res) => res)
      .catch((error) => error);
    let resData = { data: res?.data };
    return resData;
  }
);

export const CourseMapSlice = createSlice({
  name: "CourseMapSlice",
  initialState,
  reducers: {
    setEditableCourseItem: (state, action) => {
      state.editableCourseItem = action?.payload;
    },
    clearCourseMapDetails: (state) => {
      state.courseMapDetails = initialState.courseMapDetails;
    },
    setVisibleCourseElements: (state, action) => {
      state.visibleCourseElements = action?.payload;
    },
    updateCourseMapData: (state, action) => {
      state.courseMapDetails.courseMapData = action?.payload;
    },
    updateCourseMappingData: (state, action) => {
      state.courseMapDetails.courseGPSMappingData.GPSList = action?.payload;
    },
    updateClubHouseCenter: (state, action) => {
      state.courseMapDetails.courseGPSMappingData.clubLat =
        action?.payload.clubLat;
      state.courseMapDetails.courseGPSMappingData.clubLon =
        action?.payload.clubLon;
    },
    clearEditableCourseItem: (state) => {
      state.editableCourseItem = initialState.editableCourseItem;
    },
    setCourseShapePropertiesType: (state, action) => {
      state.shapePropertiesType = action?.payload;
    },
    setCoursePolygonPropertiesType: (state, action) => {
      state.polygonPropertiesType = action?.payload;
    },
    setCoursePolygonPropertiesDesc: (state, action) => {
      state.polygonPropertiesDesc = action?.payload;
    },
    setCourseBridgePropertiesDesc:  (state, action) => {
      state.bridgePropertiesDesc = action?.payload;
    },
    setCourseMarkerHazardTreeDesc: (state, action) => {
      state.markerHazardTreeDesc = action?.payload;
    },
    setCourseMarkerHazardTreeSize: (state, action) => {
      state.markerHazardTreeSize = action?.payload;
    },
    setCourseMarkerHazardTreeType: (state, action) => {
      state.markerHazardTreeType = action?.payload;
    },
    setCourseShapePropertiesSize: (state, action) => {
      state.shapePropertiesSize = action?.payload;
    },
    setSelectedCourseZoneType: (state, action) => {
      state.selectedCourseZoneType = action?.payload;
    },
    clearSelectedCourseZoneType: (state) => {
      state.selectedCourseZoneType = initialState.selectedCourseZoneType;
    },
    clearCourseShapePropertiesType: (state, action) => {
      state.shapePropertiesType = initialState.shapePropertiesType;
    },
    clearCoursePolygonPropertiesType: (state, action) => {
      state.polygonPropertiesType = initialState.polygonPropertiesType;
    },
    clearCoursePolygonPropertiesDesc: (state, action) => {
      state.polygonPropertiesDesc = initialState.polygonPropertiesDesc;
    },
    clearCourseShapePropertiesSize: (state, action) => {
      state.shapePropertiesSize = initialState.shapePropertiesSize;
    },
    clearCourseBridgePropertiesDesc: (state, action) => {
      state.bridgePropertiesDesc = initialState.bridgePropertiesDesc;
    },
    
    clearCourseCliffDesc: (state, action) => {
      state.cliffPropertiesDesc = initialState.cliffPropertiesDesc;
    },
    setCourseCliffType: (state, action) => {
      state.cliffPropertiesType = action.payload;
    },
    clearCourseCliffType: (state, action) => {
      state.cliffPropertiesType = initialState.cliffPropertiesType;
    },
    clearCourseNativeAreaDesc: (state, action) => {
      state.nativeAreaPolygonDesc = initialState.nativeAreaPolygonDesc;
    },
    clearCourseNativeAreaType: (state, action) => {
      state.nativeAreaPolygonType = initialState.nativeAreaPolygonType;
    },
    clearCourseNativeAreaSize: (state, action) => {
      state.nativeAreaPolygonSize = initialState.nativeAreaPolygonSize;
    },
    clearCourseMarkerHazardTreeDesc: (state, action) => {
      state.markerHazardTreeDesc = initialState.markerHazardTreeDesc;
    },
    clearCourseMarkerHazardTreeSize: (state, action) => {
      state.markerHazardTreeSize = initialState.markerHazardTreeSize;
    },
    clearCourseMarkerHazardTreeType: (state, action) => {
      state.markerHazardTreeType = initialState.markerHazardTreeType;
    },
    clearCourseForestType: (state, action) => {
      state.forestPolygonType = initialState.forestPolygonType;
    },
    setIsDrawingStatus: (state, action) => {
      state.isDrawingStatus = action.payload;
    },
    setVisibleFacilityElements: (state, action) => {
      state.visibleFacilityElements = action.payload;
    },
    clearVisibleFacilityElements: (state) => {
      state.visibleFacilityElements = initialState.visibleFacilityElements;
    },

    setCourseShapePropertiesDesc: (state, action) => {
      state.shapePropertiesDesc = action.payload;
    },
    clearCourseShapePropertiesDesc: (state) => {
      state.shapePropertiesDesc = initialState.shapePropertiesDesc;
    },
    setCourseCliffDesc: (state, action) => {
      state.cliffPropertiesDesc = action.payload;
    },
    setCourseNativeAreaDesc: (state, action) => {
      state.nativeAreaPolygonDesc = action.payload;
    },
    setCourseNativeAreaType: (state, action) => {
      state.nativeAreaPolygonType = action.payload;
    },
    setCourseNativeAreaSize: (state, action) => {
      state.nativeAreaPolygonSize = action.payload;
    },
    setCourseFixtureSize: (state, action) => {
      state.fixtureMarkerSize = action.payload;
    },
    setCourseFixtureType: (state, action) => {
      state.fixtureMarkerType = action.payload;
    },
    setCourseForestType: (state, action) => {
      state.forestPolygonType = action.payload;
    },
    setCourseShapeBackgroundType: (state, action) => {
      state.shapeBackgroundPropertiesType = action.payload;
    },
    setCourseShapeBackgroundDesc: (state, action) => {
      state.shapeBackgroundPropertiesDesc = action.payload;
    },
    setCourseCreekSize: (state, action) => {
      state.creekSizeValue = action.payload;
    },
    clearCourseCreekSize: (state) => {
      state.creekSizeValue = initialState.creekSizeValue;
    },
    setCourseLavaType: (state, action) => {
      state.lavaTypeValue = action.payload;
    },
    clearCourseLavaType: (state) => {
      state.lavaTypeValue = initialState.lavaTypeValue;
    },
    setCourseResidenceDesc: (state, action) => {
      state.residenceDescValue = action.payload;
    },
    clearCourseResidenceDesc: (state) => {
      state.residenceDescValue = initialState.residenceDescValue;
    },
    setCourseResidenceType: (state, action) => {
      state.residenceTypeValue = action.payload;
    },
    clearCourseResidenceType: (state) => {
      state.residenceTypeValue = initialState.residenceTypeValue;
    },
    setCourseResidenceSize: (state, action) => {
      state.residenceSizeValue = action.payload;
    },
    clearCourseResidenceSize: (state) => {
      state.residenceSizeValue = initialState.residenceSizeValue;
    },
    setCourseBuildingDesc: (state, action) => {
      state.buildingDescValue = action.payload;
    },
    clearCourseBuildingDesc: (state) => {
      state.buildingDescValue = initialState.buildingDescValue;
    },
    setCourseBuildingType: (state, action) => {
      state.buildingTypeValue = action.payload;
    },
    clearCourseBuildingType: (state) => {
      state.buildingTypeValue = initialState.buildingTypeValue;
    },
    setCourseBuildingSize: (state, action) => {
      state.buildingSizeValue = action.payload;
    },
    clearCourseBuildingSize: (state) => {
      state.buildingSizeValue = initialState.buildingSizeValue;
    },
    setCourseParkingLotDesc: (state, action) => {
      state.parkingLotDescValue = action.payload;
    },
    clearCourseParkingLotDesc: (state) => {
      state.parkingLotDescValue = initialState.parkingLotDescValue;
    },
    setCourseStreetDesc: (state, action) => {
      state.streetDescValue = action.payload;
    },
    clearCourseStreetDesc: (state) => {
      state.streetDescValue = initialState.streetDescValue;
    },
    setCourseStreetSize: (state, action) => {
      state.streetSizeValue = action.payload;
    },
    clearCourseStreetSize: (state) => {
      state.streetSizeValue = initialState.streetSizeValue;
    },
    setCourseFenceDesc: (state, action) => {
      state.fenceDescValue = action.payload;
    },
    clearCourseFenceDesc: (state) => {
      state.fenceDescValue = initialState.fenceDescValue;
    },
    setCourseFenceSize: (state, action) => {
      state.fenceSizeValue = action.payload;
    },
    clearCourseFenceSize: (state) => {
      state.fenceSizeValue = initialState.fenceSizeValue;
    },
    setCourseWaterDesc: (state, action) => {
      state.waterDescValue = action.payload;
    },
    clearCourseWaterDesc: (state) => {
      state.waterDescValue = initialState.waterDescValue;
    },
    setCourseWaterType: (state, action) => {
      state.waterTypeValue = action.payload;
    },
    clearCourseWaterType: (state) => {
      state.waterTypeValue = initialState.waterTypeValue;
    },
    setCourseWaterSize: (state, action) => {
      state.waterSizeValue = action.payload;
    },
    clearCourseWaterSize: (state) => {
      state.waterSizeValue = initialState.waterSizeValue;
    },
    setCoursePathDesc: (state, action) => {
      state.pathDescValue = action.payload;
    },
    clearCoursePathDesc: (state) => {
      state.pathDescValue = initialState.pathDescValue;
    },
    setCourseClubhouseDesc: (state, action) => {
      state.clubhouseDescValue = action.payload;
    },
    clearCourseClubhouseDesc: (state) => {
      state.clubhouseDescValue = initialState.clubhouseDescValue;
    },
    setCourseClubhouseType: (state, action) => {
      state.clubhouseTypeValue = action.payload;
    },
    clearCourseClubhouseType: (state) => {
      state.clubhouseTypeValue = initialState.clubhouseTypeValue;
    },
    setCourseClubhouseSize: (state, action) => {
      state.clubhouseSizeValue = action.payload;
    },
    clearCourseClubhouseSize: (state) => {
      state.clubhouseSizeValue = initialState.clubhouseSizeValue;
    },
    clearGoogleLocationData: (state) => {
      state.google_location_data = initialState.google_location_data;
    },
    setTransformedCourseData: (state, action) => {
      state.transformedCourseData = action.payload;
    },
    setTransformedHoleData: (state, action) => {
      state.transformedHoleData = action.payload;
    },
    clearTransformedDataSet: (state) => {
      state.transformedCourseData = initialState.transformedCourseData;
      state.transformedHoleData = initialState.transformedHoleData;
    },
    setEnableMoveMode: (state, action) => {
      state.isMoveModeEnabled = action.payload;
    },
    setMovableMapElement: (state, action) => {
      state.movableMapElement = action.payload;
    },
    clearMovableMapElement: (state) => {
      state.movableMapElement = initialState.movableMapElement;
    },
    clearMappingNoteList: (state) => {
      state.course_mapping_note_list = initialState.course_mapping_note_list;
    },
    setCopiedCourseData: (state, action) => {
      state.copiedCourseDetails = action?.payload;
    },
    setfilteredCourseHoleData: (state, action) => {
      state.holeWiseData = action?.payload;
    },
    setEditedMarkerPointToBlink : (state, action) => {
      state.selectedEditedMarkerPoint = action.payload
    },
    setMarkerLocations: (state, action) => {
      state.setMarkerPointLatlon = action.payload
    },
    setSelectedHoleNumber: (state, action) => {
      state.selectedHoleNo = action?.payload;
    },
  
  },
  extraReducers: (builder) => {
    builder

      // global save 1- CourseGPSVectorMapCreate
      .addCase(course_sync_output_create.pending, (state) => {
        state.course_sync_output_create_status = "loading";
        state.global_save_status = "loading";
      })
      .addCase(course_sync_output_create.fulfilled, (state, { payload }) => {
        state.course_sync_output_create_status = "idle";
      })
      .addCase(course_sync_output_create.rejected, (state) => {
        state.course_sync_output_create_status = "idle";
        state.global_save_status = "idle";
      })

      // global save 2- VectorOutputCreate
      .addCase(vector_output_create.pending, (state) => {
        state.vector_output_create_status = "loading";
      })
      .addCase(vector_output_create.fulfilled, (state, { payload }) => {
        state.vector_output_create_status = "idle";
        state.global_save_status = "idle";
      })
      .addCase(vector_output_create.rejected, (state) => {
        state.vector_output_create_status = "idle";
        state.global_save_status = "idle";
      })

      //vector details
      .addCase(course_map_gps_vector_details.pending, (state) => {
        state.course_gps_vector_details_status = "loading";
      })
      .addCase(
        course_map_gps_vector_details.fulfilled,
        (state, { payload }) => {
          state.course_gps_vector_details_status = "idle";
          state.courseMapDetails.courseMapData = payload?.data?.vectorGPSObject;
        }
      )
      .addCase(course_map_gps_vector_details.rejected, (state) => {
        state.course_gps_vector_details_status = "idle";
      })
      // gps name list
      .addCase(course_gps_name_list.pending, (state) => {
        state.course_gps_name_list_status = "loading";
      })
      .addCase(course_gps_name_list.fulfilled, (state, { payload }) => {
        state.course_gps_name_list_status = "idle";
        state.courseGPSNameList = payload?.data?.nameList;
        // state.courseMapDetails=payload?.data
      })
      .addCase(course_gps_name_list.rejected, (state) => {
        state.course_gps_name_list_status = "idle";
      })
      // hazard list
      .addCase(course_map_gps_mapping_details.pending, (state) => {
        state.course_gps_name_mapping_status = "loading";
      })
      .addCase(
        course_map_gps_mapping_details.fulfilled,
        (state, { payload }) => {
          state.course_gps_name_mapping_status = "idle";
          // state.courseMapDetails.courseGPSMappingData = payload?.data?.GPSList;
          state.courseMapDetails.courseGPSMappingData = payload?.data;
        }
      )
      .addCase(course_map_gps_mapping_details.rejected, (state) => {
        state.course_gps_name_mapping_status = "idle";
      })
      //CourseGPSVectorMapUpdate
      .addCase(course_gps_vector_map_update.pending, (state) => {
        state.course_gps_vector_map_update_status = "loading";
      })
      .addCase(course_gps_vector_map_update.fulfilled, (state, { payload }) => {
        state.course_gps_vector_map_update_status = "idle";
      })
      .addCase(course_gps_vector_map_update.rejected, (state) => {
        state.course_gps_vector_map_update_status = "idle";
      })
      //CourseGPSVectorMapCreate
      .addCase(course_gps_vector_map_create.pending, (state) => {
        state.course_gps_vector_map_create_status = "loading";
      })
      .addCase(course_gps_vector_map_create.fulfilled, (state, { payload }) => {
        state.course_gps_vector_map_create_status = "idle";
      })
      .addCase(course_gps_vector_map_create.rejected, (state) => {
        state.course_gps_vector_map_create_status = "idle";
      })
      //Google Geocode
      .addCase(fetch_google_geocode.pending, (state) => {
        state.google_geocode_api_status = "loading";
      })
      .addCase(fetch_google_geocode.fulfilled, (state, { payload }) => {
        state.google_geocode_api_status = "idle";
        state.google_location_data = payload?.results[0];
      })
      .addCase(fetch_google_geocode.rejected, (state) => {
        state.google_geocode_api_status = "idle";
      })
      // Scorecard details get_scorecard_details
      .addCase(course_scorecard_details.pending, (state) => {
        state.course_scorecard_details_status = "loading";
      })
      .addCase(course_scorecard_details.fulfilled, (state, { payload }) => {
        state.course_scorecard_details_status = "idle";
        state.course_scorecard_details=payload?.data
      })
      .addCase(course_scorecard_details.rejected, (state) => {
        state.course_scorecard_details_status = "idle";
      })
      //Mapping Note list
      .addCase(course_mapping_note_list.pending, (state) => {
        state.course_mapping_note_list_status = "loading";
      })
      .addCase(course_mapping_note_list.fulfilled, (state, { payload }) => {
        state.course_mapping_note_list_status = "idle";
        state.course_mapping_note_list=payload?.data
      })
      .addCase(course_mapping_note_list.rejected, (state) => {
        state.course_mapping_note_list_status = "idle";
      })
      // Mapping Note Create
      .addCase(course_mapping_note_create.pending, (state) => {
        state.course_mapping_note_create_status = "loading";
      })
      .addCase(course_mapping_note_create.fulfilled, (state, { payload }) => {
        state.course_mapping_note_create_status = "idle";
        // state.course_mapping_note_list=payload?.data
      })
      .addCase(course_mapping_note_create.rejected, (state) => {
        state.course_mapping_note_create_status = "idle";
      })

        // course hole layout
    .addCase(course_layout_list.pending, (state) => {
      state.course_layout_list_status = "loading";
    })
    .addCase(course_layout_list.fulfilled, (state, { payload }) => {
      state.course_layout_list_status = "idle";
      state.course_layout_list_data = payload?.data;
    })
    .addCase(course_layout_list.rejected, (state) => {
      state.course_layout_list_status = "idle";
    })
    // course hole layout

      // course creation
      .addCase(course_create.pending, (state) => {
        state.course_create_status = "loading";
      })
      .addCase(course_create.fulfilled, (state, { payload }) => {
        state.course_create_status = "idle";
        state.course_create_data = payload?.data;
      })
      .addCase(course_create.rejected, (state) => {
        state.course_create_status = "idle";
      })
       // course creation

       //  add clubHouse lat & lon 
    .addCase(course_clubhouse_Lat_Lon_create.pending, (state) => {
      state.course_clubhouse_Lat_Lon_create_status = "loading";
    })
    .addCase(course_clubhouse_Lat_Lon_create.fulfilled, (state, { payload }) => {
      state.course_clubhouse_Lat_Lon_create_status = "idle";
      state.course_clubhouse_Lat_Lon_create_data = payload?.data;
    })
    .addCase(course_clubhouse_Lat_Lon_create.rejected, (state) => {
      state.course_clubhouse_Lat_Lon_create_status = "idle";
    })
    //  add clubHouse lat & lon 

     // course update 
     .addCase(course_update.pending, (state) => {
      state.course_update_status = "loading";
    })
    .addCase(course_update.fulfilled, (state, { payload }) => {
      state.course_update_status = "idle";
      state.course_update_data = payload?.data;
    })
    .addCase(course_update.rejected, (state) => {
      state.course_update_status = "idle";
    })
     // course update

    //  copy course 
    .addCase(course_copy.pending, (state) => {
      state.course_copy_status = "loading";
    })
    .addCase(course_copy.fulfilled, (state, { payload }) => {
      state.course_copy_status = "idle";
      state.course_copy_data = payload?.data;
    })
    .addCase(course_copy.rejected, (state) => {
      state.course_copy_status = "idle";
    })

    // language list
    .addCase(language_list.pending, (state) => {
      state.language_list_status = "loading";
    })
    .addCase(language_list.fulfilled, (state, { payload }) => {
      state.language_list_status = "idle";
      state.language_list_data = payload?.data;
    })
    .addCase(language_list.rejected, (state) => {
      state.language_list_status = "idle";
    })

    // Course Tee ColorList
    .addCase(course_teecolor_list.pending, (state) => {
      state.course_teecolor_list_status = "loading";
    })
    .addCase(course_teecolor_list.fulfilled, (state, { payload }) => {
      state.course_teecolor_list_status = "idle";
      state.course_teecolor_list_data = payload?.data;
    })
    .addCase(course_teecolor_list.rejected, (state) => {
      state.course_teecolor_list_status = "idle";
    })

    // Course Tee Type List
    .addCase(course_teetype_list.pending, (state) => {
      state.course_teetype_list_status = "loading";
    })
    .addCase(course_teetype_list.fulfilled, (state, { payload }) => {
      state.course_teetype_list_status = "idle";
      state.course_teetype_list_data = payload?.data;
    })
    .addCase(course_teetype_list.rejected, (state) => {
      state.course_teetype_list_status = "idle";
    })

    // upload course scorecard img
    .addCase(upload_coursemap_scorecard_image.pending, (state) => {
      state.upload_course_scorecard_image_status = "loading";
    })
    .addCase(upload_coursemap_scorecard_image.fulfilled, (state, { payload }) => {
      state.upload_course_scorecard_image_status = "idle";
      state.upload_course_scorecard_image_data = payload?.data;
    })
    .addCase(upload_coursemap_scorecard_image.rejected, (state) => {
      state.upload_course_scorecard_image_status = "idle";
    })

    // delete course mp scorecard img 
    
    .addCase(Delete_coursemap_scorecard_image.pending, (state) => {
      state.delete_course_scorecard_image_status = "loading";
    })
    .addCase(Delete_coursemap_scorecard_image.fulfilled, (state, { payload }) => {
      state.delete_course_scorecard_image_status = "idle";
      state.delete_course_scorecard_image_data = payload?.data;
    })
    .addCase(Delete_coursemap_scorecard_image.rejected, (state) => {
      state.delete_course_scorecard_image_status = "idle";
    })


    .addCase(create_coursemap_rendering.pending, (state) => {
      state.create_course_rendering_status = "loading";
    })
    .addCase(create_coursemap_rendering.fulfilled, (state, { payload }) => {
      state.create_course_rendering_status = "idle";
      state.create_course_rendering_data = payload?.data;
    })
    .addCase(create_coursemap_rendering.rejected, (state) => {
      state.create_course_rendering_status = "idle";
    })


    .addCase(details_coursemap_rendering.pending, (state) => {
      state.details_course_rendering_status = "loading";
      state.details_course_rendering_data = {};
      state.details_course_rendering_courseInt = null;
    })
    .addCase(details_coursemap_rendering.fulfilled, (state, { payload, meta }) => {
      state.details_course_rendering_status = "idle";
      state.details_course_rendering_data = payload?.data;
      state.details_course_rendering_courseInt = meta?.arg?.body?.id_courseInt ?? null;
    })
    .addCase(details_coursemap_rendering.rejected, (state) => {
      state.details_course_rendering_status = "idle";
    })


    .addCase(update_coursemap_rendering.pending, (state) => {
      state.update_course_rendering_status = "loading";
    })
    .addCase(update_coursemap_rendering.fulfilled, (state, { payload }) => {
      state.update_course_rendering_status = "idle";
      state.update_course_rendering_data = payload?.data;
    })
    .addCase(update_coursemap_rendering.rejected, (state) => {
      state.update_course_rendering_status = "idle";
    })


    .addCase(course_rendering_option_list.pending, (state) => {
      state.course_rendering_options_status = "loading";
    })
    .addCase(course_rendering_option_list.fulfilled, (state, { payload }) => {
      state.course_rendering_options_status = Number(payload?.data?.Status) === 1 ? "loaded" : "failed";
      state.course_rendering_options_data = payload?.data;
    })
    .addCase(course_rendering_option_list.rejected, (state) => {
      state.course_rendering_options_status = "failed";
    })


  },
});

export const {
  setEditableCourseItem,
  clearCourseMapDetails,
  setVisibleCourseElements,
  updateCourseMapData,
  updateCourseMappingData,
  clearEditableCourseItem,
  setSelectedCourseZoneType,
  clearSelectedCourseZoneType,
  setCourseShapePropertiesType,
  setCoursePolygonPropertiesType,
  setCoursePolygonPropertiesDesc,
  setCourseBridgePropertiesDesc,
  setCourseMarkerHazardTreeDesc,
  setCourseMarkerHazardTreeSize,
  setCourseMarkerHazardTreeType,
  clearCourseMarkerHazardTreeDesc,
  clearCourseMarkerHazardTreeSize,
  clearCourseMarkerHazardTreeType,
  setCourseShapePropertiesSize,
  setCourseShapePropertiesDesc,
  setCourseCliffDesc,
  setCourseNativeAreaDesc,
  setCourseNativeAreaType,
  setCourseNativeAreaSize,
  setCourseFixtureSize,
  setCourseFixtureType,
  setCourseForestType,
  setCourseShapeBackgroundType,
  setCourseShapeBackgroundDesc,
  clearCourseShapePropertiesType,
  clearCoursePolygonPropertiesDesc,
  clearCoursePolygonPropertiesType,
  clearCourseShapePropertiesSize,
  clearCourseShapePropertiesDesc,
  clearCourseBridgePropertiesDesc,
  clearCourseCliffDesc,
  setCourseCliffType,
  clearCourseCliffType,
  clearCourseNativeAreaDesc,
  clearCourseNativeAreaType,
  clearCourseNativeAreaSize,
  clearCourseForestType,
  setCourseCreekSize,
  clearCourseCreekSize,
  setCourseLavaType,
  clearCourseLavaType,
  setCourseResidenceDesc,
  clearCourseResidenceDesc,
  setCourseResidenceType,
  clearCourseResidenceType,
  setCourseResidenceSize,
  clearCourseResidenceSize,
  setCourseBuildingDesc,
  clearCourseBuildingDesc,
  setCourseBuildingType,
  clearCourseBuildingType,
  setCourseBuildingSize,
  clearCourseBuildingSize,
  setCourseParkingLotDesc,
  clearCourseParkingLotDesc,
  setCourseStreetDesc,
  clearCourseStreetDesc,
  setCourseStreetSize,
  clearCourseStreetSize,
  setCourseFenceDesc,
  clearCourseFenceDesc,
  setCourseFenceSize,
  clearCourseFenceSize,
  setCourseWaterDesc,
  clearCourseWaterDesc,
  setCourseWaterType,
  clearCourseWaterType,
  setCourseWaterSize,
  clearCourseWaterSize,
  setCoursePathDesc,
  clearCoursePathDesc,
  setCourseClubhouseDesc,
  clearCourseClubhouseDesc,
  setCourseClubhouseType,
  clearCourseClubhouseType,
  setCourseClubhouseSize,
  clearCourseClubhouseSize,
  setIsDrawingStatus,
  setVisibleFacilityElements,
  clearVisibleFacilityElements,
  updateClubHouseCenter,
  setTransformedCourseData,
  setTransformedHoleData,
  clearTransformedDataSet,
  setMovableMapElement,
  clearMovableMapElement,
  setEnableMoveMode,
  clearMappingNoteList,
  setCopiedCourseData,
  setfilteredCourseHoleData,
  setEditedMarkerPointToBlink,
  setMarkerLocations,
  setSelectedHoleNumber
} = CourseMapSlice.actions;

export default CourseMapSlice.reducer;
